<ion-content (click)="dismiss()"></ion-content>
<ion-footer class="footer">
    <ion-item *ngIf="previewAvailable" lines="none" details="false">
        <input
            class="keyboard-input"
            [type]="type"
            [placeholder]="placeholder"
            [value]="value"
            readonly
        >
        <ion-button slot="end" (click)="dismiss()" fill="clear" size="small">Cancel</ion-button>
        <ion-button slot="end" (click)="done()" size="small">Done</ion-button>
    </ion-item>
    <ion-grid>
        <ion-row>
            <ion-col (click)="typeNumber('1')" class="key">1</ion-col>
            <ion-col (click)="typeNumber('2')" class="key">2</ion-col>
            <ion-col (click)="typeNumber('3')" class="key">3</ion-col>
        </ion-row>
        <ion-row>
            <ion-col (click)="typeNumber('4')" class="key">4</ion-col>
            <ion-col (click)="typeNumber('5')" class="key">5</ion-col>
            <ion-col (click)="typeNumber('6')" class="key">6</ion-col>
        </ion-row>
        <ion-row>
            <ion-col (click)="typeNumber('7')" class="key">7</ion-col>
            <ion-col (click)="typeNumber('8')" class="key">8</ion-col>
            <ion-col (click)="typeNumber('9')" class="key">9</ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="blank-key" *ngIf="!isDecimal">&nbsp;</ion-col>
            <ion-col *ngIf="isDecimal" (click)="typeNumber('.')" class="key">.</ion-col>
            <ion-col (click)="typeNumber('0')" class="key">0</ion-col>
            <ion-col class="backslash" (click)="backslash()">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M19 21H9c-1.436 0-3.145-.88-3.977-2.046l-2.619-3.667l-1.188-1.661c-.246-.344-.249-.894-.008-1.241l1.204-1.686L5.02 7.046C5.855 5.879 7.566 5 9 5h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3zM3.229 12.999l.806 1.125l2.618 3.667C7.104 18.424 8.223 19 9.001 19h10c.552 0 1-.45 1-1.001V8c0-.551-.448-1-1-1h-10c-.776 0-1.897.576-2.351 1.209l-2.608 3.652l-.813 1.138zM13.707 13l2.646-2.646a.502.502 0 0 0 0-.707a.502.502 0 0 0-.707 0L13 12.293l-2.646-2.646a.5.5 0 0 0-.707.707L12.293 13l-2.646 2.646a.5.5 0 0 0 .707.708L13 13.707l2.646 2.646a.5.5 0 1 0 .708-.706L13.707 13z" fill="#626262"/></svg>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-footer>